import React, { useState } from "react";
import { Button, FormErrors } from "@squirrellearningltd/go-teacher-components";
import { useForm } from 'react-hook-form';
import { useMutation } from '@apollo/react-hooks';
import * as Yup from 'yup';
import { EDIT_SUPERADMIN, GET_COUNTRY_ADMINS, GET_SUPERADMINS } from '../services/graphql';

const EditUser = ({ close, user }) => {

    const [formErrors, setFormErrors] = useState([]);

    const [editSuperAdminUser, { loading }] = useMutation(EDIT_SUPERADMIN, {
        awaitRefetchQueries: true,
        onCompleted: data => {
            if (data.editSuperAdminUser.errors && data.editSuperAdminUser.errors.length !== 0) {
                setFormErrors(data.editSuperAdminUser.errors);
                return;
            }
            if (data.editSuperAdminUser.user && data.editSuperAdminUser.user.id) {
                close()
            }
        },
        refetchQueries: [{ query: GET_SUPERADMINS }, { query: GET_COUNTRY_ADMINS}]
    });


    const schema = Yup.object().shape({
        firstName: Yup.string()
            .required('Please enter a first name for the admin.'),
        lastName: Yup.string()
            .required('Please enter a last name for the admin.'),
        email: Yup.string().email()
            .required('Please enter a valid email address.')
    });

    const { register, handleSubmit, errors } = useForm({
        validationSchema: schema
    });

    const onSubmit = values => {
        const { firstName, lastName, email, indiaOnly } = values;
        editSuperAdminUser({
            variables: {
                userId: user.id,
                firstName,
                lastName,
                email,
                ...(indiaOnly && { country: 'IND' })
            }
        })
    }

    return (
        <>
            <form onSubmit={handleSubmit(onSubmit)}>
                <h2 className="u-m-base-3">Edit: {user.firstName} {user.lastName}</h2>
                <div className="basic-form__group">
                    <label htmlFor="firstName" className="basic-form__text-label">First name</label>
                    <input
                        name="firstName"
                        placeholder="First Name"
                        className="basic-form__text-box"
                        ref={register}
                        defaultValue={user.firstName}
                        type="text"
                    />
                </div>
                {errors.firstName && <p className="basic-form__hint">{errors.firstName.message}</p>}
                <div className="basic-form__group">
                    <label htmlFor="lastName" className="basic-form__text-label">Last name</label>
                    <input
                        name="lastName"
                        placeholder="Last Name"
                        className="basic-form__text-box"
                        ref={register}
                        defaultValue={user.lastName}
                        type="text"
                    />
                </div>
                {errors.lastName && <p className="basic-form__hint">{errors.lastName.message}</p>}
                <div className="basic-form__group">
                    <label htmlFor="emal" className="basic-form__text-label">Email</label>
                    <input
                        name="email"
                        placeholder="Email"
                        className="basic-form__text-box"
                        ref={register}
                        defaultValue={user.email}
                        type="text"
                    />
                </div>
                {errors.email && <p className="basic-form__hint">{errors.email.message}</p>}


                <div className='basic-form__group basic-form__group--check u-m-base-3'>
                    <input
                        type='checkbox'
                        className="basic-form__check-box"
                        id={'india'}
                        defaultChecked={user.countryAdmin === 'IND'}
                        name='indiaOnly'
                        ref={register}
                    />
                    <label className="basic-form__check-label" htmlFor={'india'}>India only SuperAdmin</label>
                </div>

                {formErrors && <FormErrors errors={formErrors} />}
                <Button disabled={loading}>{loading ? 'Saving' : 'Save'}</Button>
            </form>
        </>
    )
}

export default EditUser;